export default "https://cdn-static.gokick.com/assets/c736ccdc0086f37925b8733f1854c980393ad61e/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";